import React,{useState} from 'react';
import {Box, Stack} from '@mui/material';
import TopBar from "../../../../../../../component/TopBar";
import ActiveBar from "../../../../../../../component/PolicyNavbar";
import BtnSecondary from '../../../../../../../component/SecondaryButton';
import SortBy from './SortBy';
import CreateGroup from '../../../../../../../component/CreateGroup';
import { useLocation } from 'react-router';
import { WizardCard } from '../../../../../../../component/wizard';

const AssignPolicy = () => {

  const [page, setPage] = useState("sortBy");
  const {state} = useLocation();

  const loadNextPage = (p) => {
    setPage(p);
  };

  const commonProps = {
    loadNextPage,
    policyId:state?.policyId
  };

  const sortByProps = {
    ...commonProps,
  };

  const createGroupProps = {
    ...commonProps,
    redirectLink: "/app/leave-policy/assign-policy", 
  };


  const mapPages = {
    sortBy: (props) => <SortBy {...sortByProps} />,
    createGroup: (props) => <CreateGroup {...createGroupProps} />,
  };

  const ShowPage = mapPages[page];
 
  return (
      <Box sx={{width:"100%"}}>
          <TopBar MainHeading={"Leave Policy"} breadcrumbs={[{label:"Leave Policy", href:"/app/leave-policy"},{label:"Assign"}]}/>
          <WizardCard>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar active={["Policy Details","Assign Policy"]}/>
                <BtnSecondary
                  sx={{ height: "2.5rem", px: "1.25rem", borderRadius: "10px" }}
                  onClick={()=>{page==="sortBy"?loadNextPage("createGroup"):loadNextPage("sortBy")}}
                >
                    {page==="sortBy"?"+ Create Group":"Back"}
                </BtnSecondary>
            </Stack>
            <ShowPage/>
          </WizardCard>
      </Box>
    )
}

export default AssignPolicy;